module.exports = {
	"pt": {
		"help-tool": {
			"button-text": "Ajuda",
			"support-button": "Obter assistência",
			"support-page": {
				"create-ticket": {
					"title": "Obter assistência",
					"instructions": "Envie um pedido abaixo e entraremos em contacto consigo dentro de 1 dia útil.",
					"related-content": {
						"title": "Estes podem ajudar a resolver o seu problema"
					},
					"fields": {
						"mid": {
							"label": "Selecionar loja",
							"validation": "Loja necessária"
						},
						"phoneNumber": {
							"label": "Número de telefone (opcional)"
						},
						"topic": {
							"question": "Com que se relaciona a sua pergunta?",
							"label": "Selecionar um tópico",
							"validation": "Tópico necessário",
							"options": {
								"orders": "Encomendas",
								"settlements": "Liquidações",
								"agreements": "Acordos",
								"others": "Outro"
							}
						},
						"subject": {
							"label": "Assunto",
							"validation": "Assunto obrigatório"
						},
						"description": {
							"label": "Mensagem",
							"validation": "Descrição obrigatória"
						},
						"attachment": {
							"label": "Adicionar anexos",
							"button": "Carregar",
							"info": "Adicionar capturas de ecrã irá ajudar-nos a resolver o problema mais rapidamente.",
							"supportedFileTypes": "Tipos de ficheiros suportados: .png, .jpg, .pdf",
							"error": "O tamanho total dos ficheiros não pode exceder {maxSize} MB"
						}
					},
					"submit": "Enviar pedido",
					"service-unavailable-error": "Ups! Ocorreu um erro, tente novamente dentro de alguns minutos. Se isto continuar, {link} para obter ajuda.",
					"generic-error": "Não foi possível processar o seu pedido. Os nossos sistemas não estão a comunicar uns com os outros neste momento. Tente recarregar ou volte mais tarde. Se isto continuar, {link} para obter ajuda.",
					"contact-link": "contacte-nos"
				},
				"view-ticket": {
					"title": "Tudo feito!",
					"details": "Recebemos o seu pedido e iremos responder-lhe em breve dentro de 1 dia útil. Aqui estão os seus detalhes:",
					"ticket": "Pedido n.º {ticketId}",
					"email": "E-mail: {email}",
					"status": "Pode seguir o estado na nossa página de Apoio ao cliente.",
					"track": "Seguir o estado"
				}
			},
			"header": {
				"homeLink": "Repor"
			},
			"home": {
				"greeting": "Olá, {givenName}! Como podemos ajudá-lo(a)?",
				"topics": "Em que precisa de ajuda?"
			},
			"topics": {
				"expandButton": "Mais"
			},
			"feedback": {
				"title": "Isto foi útil?",
				"optionYes": "Sim, isto foi útil",
				"optionNo": "Não, preciso de mais ajuda",
				"positiveFeedback": "Obrigado pelo feedback positivo; isto ajuda-nos a fornecer-lhe mais artigos relevantes no futuro."
			},
			"freeTextFeedback": {
				"title": "Ajude-nos a melhorar",
				"placeholder": "Porque não achou este conteúdo útil?",
				"submitButton": "Enviar",
				"feedbackMessage": "Obrigado pelo feedback; isto ajuda-nos a fornecer-lhe mais artigos relevantes no futuro."
			},
			"relatedContent": {
				"title": "Conteúdo relacionado"
			},
			"search": {
				"buttonLabel": "Procurar",
				"input": "Procurar artigos…",
				"loading": "A carregar…",
				"results": {
					"contact": "Não consegue encontrar a ajuda de que precisa?",
					"empty": "Lamentamos, mas não foram encontrados resultados para a sua questão. Experimente pesquisar com um termo diferente.",
					"singleTopicFound": "Encontrámos 1 tópico",
					"multipleTopicsFound": "Encontrámos {count} tópicos",
					"singleArticleFound": "Encontrámos 1 artigo",
					"multipleArticlesFound": "Encontrámos {count} artigos"
				}
			},
			"contact": {
				"title": "Contacte-nos",
				"channelsIntro": "Contacte-nos para o(a) podermos ajudar.",
				"businessDetailsTitle": "Os dados da sua empresa",
				"businessDetailsName": "Nome da empresa",
				"businessDetailsEmail": "E-mail",
				"businessDetailsMid": "ID do comerciante",
				"phone": {
					"title": "Telefone-nos",
					"paragraph": "Pode telefonar-nos durante o horário de funcionamento nos dias úteis. Se estiver na Suécia ou no Reino Unido, também pode telefonar-nos ao fim de semana entre as 10:00 e as 16:00."
				},
				"email": {
					"title": "Enviar-nos um e-mail",
					"paragraph": "Envie-nos um e-mail e entraremos em contacto consigo assim que pudermos."
				}
			},
			"errorBoundary": {
				"title": "Ocorreu um erro",
				"message": "Lamentamos imenso, mas ocorreu um erro. Pode clicar no botão \"Voltar\" abaixo para voltar à ferramenta de ajuda ou no botão \"Obter assistência\" para nos contactar.",
				"resetButton": "Voltar",
				"errorId": "ID do erro: {errorId}"
			},
			"tour": {
				"prev": "Anterior",
				"next": "Seguinte",
				"done": "Concluído"
			},
			"notAvailableMobile": {
				"title": "Não disponível",
				"buttonBack": "Voltar",
				"paragraph": "Este conteúdo não está disponível no seu dispositivo. Experimente abrir num dispositivo com ecrã maior, tal como um computador de secretária."
			},
			"shareButton": {
				"title": {
					"article": "Partilhar uma ligação avançada para este artigo",
					"topic": "Partilhar uma ligação avançada para este tópico",
					"tour": "Partilhar uma ligação avançada para esta visita"
				},
				"radioItemHome": "Página inicial da Aplicação",
				"descriptionHome": "Abre o artigo de ajuda na Página inicial do portal do comerciante",
				"radioItemCurrent": "Página atual",
				"descriptionCurrent": "Abre o artigo na página atual"
			},
			"marketSelector": {
				"whichMarketToContact": "Que mercado gostaria de contactar?"
			}
		},
		"orientation": {
			"title": "Descubra como…"
		},
		"helpbot": {
			"questions": {
				"whatDoYouNeedHelpWithPart1": "Olá {name}! 👋 Sou o seu assistente Klarna.",
				"whatDoYouNeedHelpWithPart2": "Em muitos casos, utilizar-me ajudará a resolver a sua consulta em menos de 5 minutos.",
				"whatDoYouNeedHelpWithPart3": "Em que posso ajudar hoje?",
				"selectSupportChannel": "Selecione um canal para contactar o nosso serviço de apoio.",
				"selectPayoutIssue": "Perfeito! Prossiga e selecione uma questão relacionada com pagamentos 👇",
				"selectOrderIssue": "Perfeito! Prossiga e selecione uma questão relacionada com encomendas 👇",
				"capturedOrders": "Tem algumas encomendas {link1}?",
				"capturedOrdersLink1": "capturado",
				"notPaidOrder": {
					"isScheduleFollowed": "O seu {link1} (incluindo atraso de pagamento) está a ser seguido?",
					"isScheduleFollowedLink1": "agendamento de pagamento",
					"isHoldbackOrDebt": "Se o atraso de pagamento foi excedido, verifique o seu {link1}. Existe alguma retenção ou dívida devido a devoluções/reversões?",
					"isHoldbackOrDebtLink1": "último ficheiro de liquidação"
				},
				"paidWrongAmount": {
					"isScheduleFollowed": "Verifique a data de captura das encomendas que espera que sejam pagas e tenha em consideração o atraso no pagamento. Pode encontrar as suas encomendas {link1}. As encomendas que espera que sejam pagas estão capturadas?",
					"isScheduleFollowedLink1": "aqui"
				},
				"changePaymentFrequency": "Recebeu mais de 30 encomendas capturadas por mês ao longo de um período de 3 meses?",
				"whenWillGetPaid": "A data do pagamento dependerá do seu calendário de pagamentos e do atraso de pagamento indicado no seu contrato (T&C). Se não sabe bem qual é a configuração dos seus pagamentos, pode verificá‑la em {link1}. O plano de pagamento (com o atraso de pagamento) está a ser seguido?",
				"whenWillGetPaidLink1": "Liquidações",
				"thatHelped": "Obrigado pelo feedback positivo; isto ajuda-nos a fornecer-lhe mais ajuda relevante no futuro. 😀",
				"orders": {
					"haveUncapturedOrdersPart1": "Ah, estou a ver! Tem encomendas por capturar?",
					"haveUncapturedOrdersPart2": "Se não souber como verificar isso, vá a {link1}.",
					"haveUncapturedOrdersPart2Link1": "esta página",
					"expirationDateSurpassed": "A data de validade já passou? (normalmente são 28 dias)",
					"customerCreditPaymentMethod": "O cliente escolheu uma forma de pagamento de crédito (fatura, conta, débito direto)?",
					"isOrderCaptured": "A encomenda é {link1}?",
					"isOrderCapturedLink1": "capturado"
				}
			},
			"options": {
				"payout": "Pagamento",
				"orders": "Encomendas",
				"otherIssue": "Outros problemas",
				"whenPaidOrderNext": "Quando receberei o pagamento da próxima vez?",
				"notPaidOrder": "Não recebi um pagamento",
				"paidWrongAmount": "Recebi um pagamento com um montante errado",
				"changeHowOftenPaid": "Quero alterar a frequência com que recebo pagamentos",
				"dontKnowHowToCaptureOrder": "Não sei como capturar uma encomenda",
				"missedCaptureDeadline": "Deixei passar o prazo da captura",
				"needToRefundAnOrder": "Preciso de reembolsar uma encomenda",
				"yes": "Sim",
				"no": "Não",
				"partially": "Parcialmente",
				"iNeedMoreHelp": "Preciso de mais ajuda",
				"thatHelped": "Isso ajudou",
				"contactSupportChannel": "Contactar canais de assistência"
			},
			"explanations": {
				"noCapturedOrders": "Em primeiro lugar, precisa de {link1}. Depois de ter capturado a encomenda, faremos o pagamento do montante na sua conta bancária. Taxas, devoluções e outros encargos serão deduzidos deste montante.",
				"noCapturedOrdersLink1": "capturar uma encomenda",
				"feesReturnsHoldbacks": "Taxas, devoluções e outros encargos podem ser deduzidos do montante de pagamento. Verifique se tem qualquer retenção ou dívida devido a devoluções/reversões no {link1}.",
				"feesReturnsHoldbacksLink1": "último ficheiro de liquidação",
				"notPaidOrder": {
					"scheduleFollowed": "Depois de ter capturado a encomenda, faremos o pagamento do montante na sua conta bancária, de acordo com o plano de pagamento. Taxas, devoluções e outros encargos serão deduzidos deste montante. Verifique o valor do seu pagamento no seu {link1}.",
					"scheduleFollowedLink1": "último ficheiro de liquidação",
					"noHoldback": "Verifique que tem os dados da conta bancária certos registados para a moeda do pagamento {link1}.",
					"noHoldbackLink1": "aqui",
					"withHoldback": "Se o valor das encomendas capturadas ultrapassar a dívida, verifique que tem os dados da conta bancária certos registados para a moeda do pagamento {link1}.",
					"withHoldbackLink1": "aqui"
				},
				"whenPaidOrderNext": {
					"scheduleFollowed": "Receberá o pagamento seguinte de acordo com o plano de pagamento + atraso de pagamento."
				},
				"changePaymentFrequency": {
					"isAble": "Continue contactando a nossa assistência através dos canais abaixo.",
					"isUnable": "Infelizmente, não cumpre os requisitos para alterar o seu plano de pagamento."
				},
				"orders": {
					"uncapturedDynamicYes": "Oh, estou a ver que tem {number} encomendas por capturar.",
					"uncapturedDynamicNo": "Estou a ver que não tem encomendas por capturar",
					"uncapturedYesPart1": "Então, está na altura de capturar algumas encomendas! Para tal,",
					"uncapturedYesPart2": "1. Vá para a página da encomenda {link1}.",
					"uncapturesYesPart2Link1": "clicando aqui",
					"uncapturedYesPart3": "2. Clique na referência Klarna da encomenda que deseja capturar",
					"uncapturedYesPart4": "3. Escolha os artigos ou adicione um montante que deseja capturar",
					"uncapturedYesPart5": "4. Prima “Capturar”",
					"uncapturedNoPart1": "Para capturar uma encomenda, primeiro tem de ter encomendas para capturar.",
					"uncapturedNoPart2": "Ao capturar uma encomenda, isso significa confirmar que a encomenda foi enviada para o cliente. Isto deve ser sempre feito no mesmo dia em que a encomenda foi enviada, em todas as encomendas. Quando capturar uma encomenda, também nos informa de que devemos acionar um pagamento para si por essa encomenda. Leia mais sobre como capturar uma encomenda {link1}.",
					"uncapturedNoLink1": "aqui",
					"customerCreditPaymentMethodNo": "Infelizmente, não podemos prolongar uma encomenda que expirou. Terá de recriar a encomenda.",
					"expirationDateSurpassedYes": "Deixe-nos ajudar a prolongar a encomenda, contacte a nossa assistência através de um dos canais abaixo.",
					"expirationDateSurpassedNo": "Ir para {link1}. Selecione a encomenda assinalando a caixa ao lado do número de referência da Klarna. Clique em Prolongar data de validade e confirme o seu pedido.",
					"expirationDateSurpassedNoLink1": "Encomendas > Para capturar",
					"isOrderCapturedYesPart1": "Selecione os itens que deseja reembolsar e clique no botão Reembolso. Também pode clicar em Reembolso primeiro e introduzir o montante que pretende reembolsar – escolha a forma que lhe der mais jeito.",
					"isOrderCapturedYesPart2": "O seu cliente receberá um reembolso do valor que já pagou, no prazo de 2-5 dias úteis. E verá este valor deduzido do seu próximo pagamento.",
					"isOrderCapturedNo": "Se tiver uma encomenda não capturada que não irá enviar, pode {link1} toda a encomenda. Vá ao {link2} e clique em Cancelar encomenda.",
					"isOrderCapturedNoLink1": "cancelar",
					"isOrderCapturedNoLink2": "página da encomenda",
					"refundPartiallyCaptured": "Se capturou parcialmente a encomenda para os itens que encomendou e não enviará os restantes, deve libertar a parte não capturada da encomenda. Vá a {link1}, clique em Mais ações e selecione Libertar.",
					"refundPartiallyCapturedLink1": "página da encomenda"
				}
			},
			"messages": {
				"sorryToHearThat": "Lamento não ter sido útil. Será redirecionado/a para contactar a nossa assistência."
			},
			"button": {
				"label": "Obter assistência"
			},
			"contact": {
				"chat": "Conversar por chat com um agente",
				"ticket": "Enviar um bilhete",
				"times": {
					"minutes": "Tempo de espera: {time} minuto(s)",
					"hours": "Tempo de espera: {time} hora(s)",
					"days": "Tempo de espera: {time} dia(s)"
				}
			}
		}
	}
};